import Castilo81 from './Castilo 8.webp'
import Castilo82 from './Castilo 8.webp'





const Castilo8images =[
Castilo81,Castilo82
]

export default Castilo8images;